import React, { useEffect, useMemo, useState } from "react";
import "./verification.css";
import Widgets from "../../widgets";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import Component from "..";
import { useDispatch, useSelector } from "react-redux";
import { resetPersonalInfo } from "../../modules/patientProfile/patientProfileSlice";
import { getPersonalInfo, getEditRequest } from "../../modules/patientProfile/patientProfileThunk";
import ToastPopup from "../../widgets/Toast/toastPopup";
import { setVerifyType } from "../../modules/status/verificationType";
import i18next from "i18next";

const Verification = ({ setSelectedView, userId }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { status: gotStatus } = useSelector((state) => state.status);
  const verifyType = useSelector((state) => state.verifyType.type);
  const location = useLocation();
  const navigate = useNavigate();
  const navData = location?.state;
  // const verifyType = "editReq";
  const breadcrumbs = ["patientProfiles", "patientDetails"];
  const paths = [
    {
      path: "/patient-profile",
      onClick: () => setSelectedView("patientProfileList"),
    },
    { path: "/patient-profile" },
  ];
  const [status, setStatus] = useState("OPEN");
  const [occupiedTags, setOccupiedTags] = useState([]);
  const [page, setPage] = useState(1);
  const [steps, setSteps] = useState([`${t("patientDetails")}`, `${t("currentAdd")}`, `${t("nationalID")}`, `${t("insurance")}`, `${t("generateHn")}`]);
  const [enabledSteps, setEnabledSteps] = useState([1]);
  const [currentStep, setCurrentStep] = useState(1);
  const [hasHn, setHasHn] = useState(true);
  const [editProfileData, setEditProfileData] = useState();
  const [hnVerificationRequest, setHnVerificationRequest] = useState("");
  const { personalInfo, personalInfoError, patientEditRequest, patientEditRequestError } = useSelector((state) => state.patientProfile);

    useEffect(() => {
    setSteps([
      t("patientDetails"),
      t("currentAdd"),
      t("nationalID"),
      t("insurance"),
      t("generateHn"),
    ]);
  }, [i18next.language]);

  useEffect(() => {
    if (personalInfoError) {
      ToastPopup.error(personalInfoError);
      setSelectedView("patientProfileList");
      navigate(location.path, {
        state: null,
        replace: true,
      });
    }
    if (personalInfo && personalInfo.status === "success") {
      setHnVerificationRequest(personalInfo.data.hnVerificationOpenRequest);
      setOccupiedTags(personalInfo.data?.occupiedTags);
      setStatus(personalInfo.data.hnVerificationOpenRequest.status);
      setPage(1);
      if (personalInfo.data.hnVerificationOpenRequest.status === "VERIFIED") {
        ToastPopup.error(t("profileAlreadyVerified"));
        setSelectedView("patientProfileList");
      }
      if (personalInfo.data.hnVerificationOpenRequest.relative.hnNumber) {
        dispatch(setVerifyType("withHN"));
      } else {
        dispatch(setVerifyType("withoutHN"));
      }
    }

    dispatch(resetPersonalInfo());
  }, [personalInfo, personalInfoError]);

  useEffect(() => {
    if (patientEditRequest && patientEditRequest.status === "success") {
      setEditProfileData(patientEditRequest.data);
    }
  }, [patientEditRequest, patientEditRequestError]);

  useEffect(() => {
    if ((userId && verifyType === "withHN") || verifyType === "withoutHN") {
      dispatch(getPersonalInfo({ userId }));
    }
  }, [userId]);

  useEffect(() => {
    if (patientEditRequestError) {
      ToastPopup.error(personalInfoError);
      setSelectedView("patientProfileList");
    }
    if (userId && verifyType === "editReq") {
      dispatch(getEditRequest({ userId }));
    }
  }, [userId]);

  useEffect(() => {
    if (gotStatus) {
      setStatus(gotStatus);
    }
  }, [gotStatus]);

  useEffect(() => {
    if (page > enabledSteps.length) {
      setEnabledSteps([...enabledSteps, page]);
    }
  }, [page]);

  useEffect(() => {
    setCurrentStep(page);
  }, [page]);

  const hnNumber = hnVerificationRequest?.relative?.hnNumber;
  useEffect(() => {
    if (verifyType === "editReq") {
      setSteps([t("patientDetails"), t("insurance")]);
    }
    if (verifyType === "withHN") {
      setHasHn(false);
    }
    if (hnNumber === null && navData?.id === userId) {
      setHasHn(true);
    }
    if (verifyType === "withoutHN") {
      setHasHn(true);
    }
  }, [verifyType, navData]);
  let headingText;
  switch (verifyType) {
    case "withHN":
      headingText = t("validateHn");
      break;
    case "withoutHN":
      headingText = t("generateHn");
      break;
    case "editReq":
      headingText = t("verifyUpdateReq");
      break;
    default:
      headingText = t("validateHn");
  }

  const handleStepChange = (stepIndex) => {
    setCurrentStep(stepIndex);
    setPage(stepIndex);
  };

  // if (!hnVerificationRequest) {
  //   return null;
  // }

  return (
    <div className="verification-container">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="department-heading-row">
        <div className="department-heading">{headingText}</div>
        <div className={`dep-status-btn ${status}`}>{t(status)}</div>
      </div>
      <Widgets.ProgressBar steps={steps} currentStep={currentStep} enabledSteps={enabledSteps} onStepChange={handleStepChange} />

      {page === 1 && verifyType !== "editReq" && (
        <Component.PersonalInfo
          userProfile={hnVerificationRequest.relative}
          setRequestData={setHnVerificationRequest}
          setStatus={setStatus}
          setSelectedView={setSelectedView}
          setPage={setPage}
          userId={userId}
          hasHn={hasHn}
          status={status}
        />
      )}
      {page === 2 && verifyType !== "editReq" && (
        <Component.PatientAddress
          userAddress={hnVerificationRequest.userAddress}
          setRequestData={setHnVerificationRequest}
          setSelectedView={setSelectedView}
          setPage={setPage}
          userId={userId}
          hasHn={hasHn}
          occupiedTags={occupiedTags}
        />
      )}
      {page === 3 && verifyType !== "editReq" && (
        <Component.PatientNationalId
          userNationalId={hnVerificationRequest.nationalId}
          setRequestData={setHnVerificationRequest}
          setSelectedView={setSelectedView}
          setPage={setPage}
          userId={userId}
          hasHn={hasHn}
          countryId={hnVerificationRequest.relative?.country}
        />
      )}
      {page === 4 && verifyType !== "editReq" && (
        <Component.PatientInsurance
          userInsurance={hnVerificationRequest.insurance}
          setRequestData={setHnVerificationRequest}
          setSelectedView={setSelectedView}
          setPage={setPage}
          userId={userId}
          caterogy={hnVerificationRequest?.insuranceCategoryToShow}
          hasHn={hasHn}
        />
      )}
      {page === 5 && verifyType !== "editReq" && (
        <Component.GenerateHn setSelectedView={setSelectedView} setPage={setPage} userId={userId} requestData={hnVerificationRequest} setRequestData={setHnVerificationRequest} />
      )}
      {page === 1 && verifyType === "editReq" && <Component.editPersonalInfo setSelectedView={setSelectedView} setPage={setPage} editProfileData={editProfileData} userId={userId} />}
      {page === 2 && verifyType === "editReq" && <Component.VerifyInsurance setSelectedView={setSelectedView} setPage={setPage}  userId={userId} />}
    </div>
  );
};

export default Verification;
